module.exports = __webpack_public_path__ + "img/out-of-money.1cc54650.svg";